// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__2UzkR","col":"CardReaderDesc_col__1CNcl","label":"CardReaderDesc_label__3k9gt"};